export default function EditFormSkeleton() {
  return (
    <form className="space-y-6 max-w-3xl text-left animate-pulse">
      <div className="mb-4">
        <div className="h-4 bg-gray-200 rounded w-32 mb-2" />
        <div className="h-10 bg-gray-200 rounded w-full" />
      </div>
      <div className="mb-4">
        <div className="h-4 bg-gray-200 rounded w-32 mb-2" />
        <div className="h-10 bg-gray-200 rounded w-full" />
      </div>
      <div className="mb-4">
        <div className="h-4 bg-gray-200 rounded w-32 mb-2" />
        <div className="h-10 bg-gray-200 rounded w-full" />
      </div>
      <div className="mb-4">
        <div className="h-4 bg-gray-200 rounded w-32 mb-2" />
        <div className="h-10 bg-gray-200 rounded w-full" />
      </div>
      <div className="mb-4">
        <div className="h-4 bg-gray-200 rounded w-40 mb-2" />
        <div className="h-8 bg-gray-200 rounded w-16" />
      </div>
      <div className="mt-6 flex justify-end gap-4">
        <div className="h-10 bg-gray-200 rounded w-24" />
        <div className="h-10 bg-gray-200 rounded w-24" />
      </div>
    </form>
  );
}